import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import {Button} from 'antd';
import _ from 'lodash';

import labels from '../../../config/labels.json';
import {ILabel} from '../../../config/lebels-type';
import {APPLICATION} from '../../../config/routes';
import {Card} from '../Card';



export const WidgetApplication = () => {
    const {t} = useTranslation();
    const navigate = useNavigate();

    const labelGroup = _.filter(labels, (label: ILabel) => label.identifier === 'anket')[0];

    // загружаем данные виджета
    // ищем последние данны
    const welcomeText = t(labelGroup.welcome!)

    return (
        <Card title={t(labelGroup.label)} icon={labelGroup.icon}>
            <div>{welcomeText}</div>
            <Button type={'primary'} onClick={() => navigate(APPLICATION)}>Заполнить данные</Button>
        </Card>
    )

}